import { Component, inject, signal, OnDestroy, OnInit } from '@angular/core';
import { MatOptionModule, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { StorageService } from '../../services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { AsyncPipe, NgClass, NgFor } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { map, Subject, takeUntil } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import 'moment/locale/ru';

@Component({
  selector: 'wm-libs-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, NgFor, AsyncPipe, NgClass, MatOptionModule, MatInputModule, MatDatepickerModule, MatButtonModule],
})
export class LanguageSelectComponent implements OnInit, OnDestroy {
  langs = environment.langs.map((lang) => ({
    code: lang,
    name: lang.toUpperCase(),
  }));
  defaultLang = environment.defaultLang;
  selectedLang = this.defaultLang;
  _unsubscribe$: Subject<void> = new Subject<void>();

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium]).pipe(map((result) => result.matches));

  private readonly _adapter = inject<DateAdapter<unknown, unknown>>(DateAdapter);
  private readonly _locale = signal(inject<unknown>(MAT_DATE_LOCALE));

  constructor(private translate: TranslateService, private storageService: StorageService, private breakpointObserver: BreakpointObserver) {}

  ngOnInit() {
    const storedLang = this.storageService.getUserLang();
    this.selectedLang = storedLang || this.defaultLang || 'en';

    this.onChangeLanguage(this.selectedLang);

    this.translate.onLangChange.pipe(takeUntil(this._unsubscribe$)).subscribe((event) => {
      this.selectedLang = event.lang;
    });
  }

  onChangeLanguage(value: string) {
    this.translate.use(value);
    this.selectedLang = value;
    this.storageService.setUserLang(value);

    this._locale.set(value);
    this._adapter.setLocale(this._locale());
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
